import { Component, ViewContainerRef, OnInit, ViewEncapsulation, EventEmitter, Output, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/common-models';
import { DynamicFormService } from '../../service/dynamic-form.service';
import { MyErrorStateMatcher } from '../../models/error-matcher';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['form-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormInputComponent implements Field, OnInit, AfterViewInit {
  decimalNumbersOnly: boolean;
  // @Output() valueChange EventEmitter<any> = new EventEmitter<any>()
  constructor(public dfs: DynamicFormService, private cdf: ChangeDetectorRef, public gs: GuestService) { }
  matcher = new MyErrorStateMatcher();

  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  public FormControlName;
  config: FieldConfig;
  group: UntypedFormGroup;
  onlyNumber: any;
  digitOnly: any;
  numbersDotOnly: any;
  isPhoneNumber = false;
  isAlphaNumeric: any;
  isNewPhoneNumber: boolean;
  prefix: string;
  inputControls: boolean = false;
  inputEmiter() {
    /*  */
    this.valueChange.emit('test');
  }

  ngOnInit() {
    this.FormControlName = this.config.name;
    this.onlyNumber = this.config.directive && this.config.directive === 'numberOnly';
    this.digitOnly = this.config.directive && this.config.directive === 'digitOnly';
    this.numbersDotOnly = this.config.directive && this.config.directive === 'numbersDotOnly';
    this.isPhoneNumber = this.config.isPhoneNumber ? this.config.isPhoneNumber : false;
    this.isAlphaNumeric = this.config.directive && this.config.directive === 'alphaNumeric';
    this.inputControls = this.config.inputControls ? this.config.inputControls : false;
    this.decimalNumbersOnly = this.config.directive && this.config.directive === 'appDecimalsOnly';
    this.prefix = this.config.prefix || null;
    if (this.config.isConciergeNumber) {
      this.isNewPhoneNumber = this.config.isNewPhoneNumber;
    }
  }

  ngAfterViewInit() {
    this.cdf.detectChanges();
  }

  increaseClicked(event) {
    if (this.config.increaseClicked) {
      this.config.increaseClicked(event, this.config.name)
    }
  }

  decreaseClicked(event) {
    if (this.config.decreaseClicked) {
      this.config.decreaseClicked(event, this.config.name)
    }
  }
  onKeyup(event) {
    if (this.config.blurClick) {
      this.config.blurClick(event);
    }

  }

  iconClick(event, ctrlName?) {
    if (this.config.cellClick) {
      this.config.cellClick(event, ctrlName);
    }
  }

  addNewPhoneNumber(action) {
    if (this.config.returnFunction) {
      this.config.returnFunction(action);
    }
    event.preventDefault();
    event.stopPropagation();
  }

  onFocusOut(event, ctrlName?) {
    if (this.config.onfocusOutClick) {
      this.config.onfocusOutClick(event, ctrlName);
    }
  }
}
